var angular=window.angular,ngModule;
try {ngModule=angular.module(["ng"])}
catch(e){ngModule=angular.module("ng",[])}
var v1="<web-component> <div class=\"product-line-image col-md-2\" style=\"min-height: 50px\"> <img ng-src=\"{{ image }}\"> </div> <div class=\"product-line-text col-md-10\"> <div class=\"row\"> <h3 class=\"product-line-header col-md-12\"> {{ amount }} <span ng-i18next>common.pcs</span>\n<span ng-i18next>{{ name }}</span> <br> {{ dateRange }} </h3> <p class=\"product-line-price col-md-12 bigamount\">{{ price | currency:'€' }}</p> </div> <p class=\"product-line-description row\"> {{ description }} </p> </div> </web-component>";
var id1="winresProductLine.html";
ngModule.run(["$templateCache",function(c){c.put(id1,v1)}]);
module.exports=v1;


//////////////////
// WEBPACK FOOTER
// ./src/webComponents/components/winresProductLine/winresProductLine.html
// module id = 442
// module chunks = 2